// chatGlowTheme.js — customizable chat background glow (gold / blue / cyan).

export const CHAT_GLOW_KEY = 'apolo:chatGlowTheme';
export const CHAT_GLOW_EVENT = 'apolo:chatGlowChanged';

export const CHAT_GLOW_THEMES = {
  gold: { label: 'Ouro', next: 'blue' },
  blue: { label: 'Azul', next: 'cyan' },
  cyan: { label: 'Ciano', next: 'gold' },
};

export function readChatGlowTheme() {
  try {
    const v = localStorage.getItem(CHAT_GLOW_KEY);
    return CHAT_GLOW_THEMES[v] ? v : 'gold';
  } catch {
    return 'gold';
  }
}

export function cycleChatGlowTheme() {
  const current = readChatGlowTheme();
  const next = CHAT_GLOW_THEMES[current]?.next || 'gold';
  try {
    localStorage.setItem(CHAT_GLOW_KEY, next);
  } catch {
    /* private mode */
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(CHAT_GLOW_EVENT, { detail: next }));
  }
  return next;
}

export function chatGlowDataAttr(theme) {
  const t = CHAT_GLOW_THEMES[theme] ? theme : 'gold';
  return { 'data-rx-glow': t };
}
